import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserFullInfoService } from '../services/user-full-info.service';

/**
 * Guarda que permite acceso solo a usuarios con permisos internos.
 * Redirige a home si el usuario no tiene ninguna.
 */
export const canActivateWithActivity: CanActivateFn = async () => {
  const userService = inject(UserFullInfoService);
  const router = inject(Router);

  await userService.loadUserInfo();

  const hasActivity = userService.canViewRestrictedDataSnapshot();

  return hasActivity ? true : router.createUrlTree(['/']);
};
